import * as React from 'react';
import LazyLoad from 'react-lazyload';
import ProductImageCardInner from './ProductImageCardInner';
import config from '../../components/LazyLoadComponents/config';

const LazyProductImageCard = props => {
  const { lazyLoad, width, height, placeholderWidth, placeholderHeight } = props;

  return !lazyLoad ? (
    <ProductImageCardInner {...props} />
  ) : (
    <LazyLoad width={placeholderWidth || width} height={placeholderHeight || height} {...config.productImageCard}>
      <ProductImageCardInner {...props} />
    </LazyLoad>
  );
};

export default LazyProductImageCard;
